import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/icon-expand.svg'


const _hoisted_1 = {
  key: 0,
  class: "main-wr",
  id: "floorplanStep"
}
const _hoisted_2 = {
  key: 0,
  class: "content-house-design-features"
}
const _hoisted_3 = { class: "content-house-design" }
const _hoisted_4 = { class: "title-house-design" }
const _hoisted_5 = {
  key: 0,
  class: "area-house-design"
}
const _hoisted_6 = { class: "content-features" }
const _hoisted_7 = { class: "content-floorplan" }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.selectedHouseDesign)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($setup.isDesktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString($setup.selectedHouseDesign?.name), 1),
                ($setup.isDesktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.formatMeters($setup.selectedHouseDesign?.area, false)) + " sqm", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode($setup["HouseFeatures"], {
                  features: $setup.selectedHouseDesign ?? _ctx.house,
                  class: _normalizeClass($setup.isDesktop ? 'house-features' : 'house-features-mobile')
                }, null, 8, ["features", "class"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          ($setup.isDesktop)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "img-floorplan",
                src: $setup.selectedHouseDesign?.floorplans[0]?.url,
                onClick: $setup.openImageModal
              }, null, 8, _hoisted_8))
            : _createCommentVNode("", true),
          ($setup.isDesktop)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "icon-expand",
                src: _imports_0,
                onClick: $setup.openImageModal
              }))
            : _createCommentVNode("", true),
          _createVNode($setup["BuilderLightboxImages"], {
            isOpen: $setup.isImageModalOpen,
            imageUrl: $setup.selectedHouseDesign?.floorplans[0]?.url,
            zoom: $setup.zoom,
            onUpdateZoom: $setup.updateZoom,
            onClose: $setup.closeImageModal
          }, null, 8, ["isOpen", "imageUrl", "zoom"]),
          (!$setup.isDesktop)
            ? (_openBlock(), _createBlock($setup["BuilderEstimatorFloorplansMobile"], {
                key: 2,
                floorplanUrl: $setup.selectedHouseDesign?.floorplans[0]?.url,
                area: $setup.selectedHouseDesign?.area,
                width: $setup.selectedHouseDesign?.width,
                length: $setup.selectedHouseDesign?.length,
                features: $setup.selectedHouseDesign?.features,
                onOpenImageModal: $setup.openImageModal
              }, null, 8, ["floorplanUrl", "area", "width", "length", "features"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}